import { useEffect, useState } from "react"

interface WindowSize {
  width: number
  height: number
}

const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState<WindowSize>({
    width: window.screen.availWidth,
    height: window.screen.availHeight
  })

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.screen.availWidth,
        height: window.screen.availHeight
      })
    }

    handleResize()

    window.addEventListener("resize", handleResize)

    return () => window.removeEventListener("resize", handleResize)
  }, [])

  return windowSize
}

export default useWindowSize
